<template>
  <div>
    <top-navbar></top-navbar>

    <div class="mb-5 background_color">
      <h6 class="manage-boder pt-2 font1 decoration">
        <router-link class="decoration" to="/">Home</router-link>
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        Users
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        <router-link class="decoration" to="/user/visitreport">User Tracking Report</router-link>
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        {{ selectedVisit ? selectedVisit.username : "Visit Details" }}
      </h6>

      <div class="container-fluid">
        <div class="d-grid gap-2 d-md-flex justify-content-md-end">
          <button
            @click="$router.push('/user/visitreport')"
            class="btn btn-sm btn-outline-primary mb-1 bdr-rad"
          >
            Back
          </button>
        </div>

        <div class="card custom_bdr_rds shadow " v-if="visitLoading">
          <div class="card-body custom_bdr_rds">
            <div class="d-flex justify-content-center">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>
        </div>

        <div v-else class="mt-1">
          <div v-if="selectedVisit">
            <div class="card custom_bdr_rds shadow p-2">
              <div class="card-body custom_bdr_rds">
                <div class="row">
                  <div class="col-md-12">
                    <table style="font-size: small;" class="table table-sm table-borderless">
                      <tbody>
                        <tr>
                          <td class="width-custom2"><b>User</b></td>
                          <td>{{ selectedVisit.username || "-" }}</td>
                          <td></td>
                        </tr>
                        <tr>
                          <td><b>Visit Time</b></td>
                          <td>{{ selectedVisit.visit_time || "-" }}</td>
                          <td></td>
                        </tr>
                        <tr>
                          <td><b>IP</b></td>
                          <td>{{ selectedVisit.ip_text || "-" }}</td>
                          <td></td>
                        </tr>
                        <tr>
                          <td><b>Action</b></td>
                          <td>{{ selectedVisit.action || "-" }}</td>
                          <td></td>
                        </tr>
                        <tr>
                          <td><b>Route</b></td>
                          <td>{{ selectedVisit.route || "-" }}</td>
                          <td></td>
                        </tr>
                        <tr>
                          <td><b>Language</b></td>
                          <td>{{ selectedVisit.language || "-" }}</td>
                          <td></td>
                        </tr>
                        <tr>
                          <td><b>Browser</b></td>
                          <td>{{ selectedVisit.browser || "-" }}</td>
                          <td></td>
                        </tr>
                        <tr>
                          <td><b>OS</b></td>
                          <td>{{ selectedVisit.os || "-" }}</td>
                          <td></td>
                        </tr>
                        <tr>
                          <td><b>User Agent</b></td>
                          <td class="break-word">{{ selectedVisit.user_agent || "-" }}</td>
                          <td></td>
                        </tr>
                        <tr>
                          <td><b>Summary</b></td>
                          <td>{{ selectedVisit.summary || "-" }}</td>
                          <td></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div class="card custom_bdr_rds shadow p-2">
              <div class="card-body custom_bdr_rds">
                <h6 class="purchitem mb-2"><b>Full Process Details</b></h6>

                <div class="table-responsive" v-if="processRows.length">
                  <table style="font-size: small;" class="table table-hover table-sm table-borderless">
                    <thead class="background_color2">
                      <tr class="custom-label2">
                        <th>#</th>
                    
                        <th>Time</th>
                        <th>Folder Location</th>
                        <th>Folder</th>
                        <th>Sub Folder</th>
                        <th>Files</th>
                        <th>Keyword</th>
                   
                        <th>Result Count</th>
                        <th>Selected Rows</th>
                        <th>Saved Name</th>
                        <th>Saved Rows</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(activity, index) in processRows" :key="activity.id || index">
                        <td>{{ index + 1 }}</td>
                   
                        <td>{{ activity.visit_time || "-" }}</td>
                        <td>{{ activity.folder_location || "-" }}</td>
                        <td>{{ activity.selected_folder || "-" }}</td>
                        <td>{{ activity.selected_sub_folder || "-" }}</td>
                        <td>{{ activity.selected_files || "-" }}</td>
                        <td>{{ activity.keyword || "-" }}</td>
                      
                        <td>{{ activity.result_count || "0" }}</td>
                        <td>{{ activity.selected_row_count || "0" }}</td>
                        <td>{{ activity.master_name || "-" }}</td>
                        <td>{{ activity.saved_rows || "0" }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div v-else class="text-muted">No search or save process recorded for this login session.</div>
              </div>
            </div>
          </div>

          <div v-else class="card custom_bdr_rds shadow p-2">
            <div class="card-body custom_bdr_rds text-muted">
              Visit details not found.
            </div>
          </div>
        </div>
      </div>
    </div>

    <Br></Br>
    <content-footer></content-footer>
  </div>
</template>

<script>
import axios from "axios";
import authService from "@/auth.service";
import TopNavbar from "./../../layout/TopNavbar.vue";
import ContentFooter from "./../../layout/ContentFooter.vue";

export default {
  components: {
    TopNavbar,
    ContentFooter
  },

  data() {
    return {
      access_token: authService.isLoggedIn(),
      id: this.$route.query.id,
      visitLoading: true,
      selectedVisit: null
    };
  },

  computed: {
    processRows() {
      if (!this.selectedVisit || !this.selectedVisit.activities) {
        return [];
      }

      const activities = this.selectedVisit.activities;
      const processRows = [];

      activities.forEach((activity, index) => {
        const action = (activity.action || "").toLowerCase();

        if (action !== "search") {
          return;
        }

        const details = activity.details || {};
        let saveActivity = null;

        for (let nextIndex = index + 1; nextIndex < activities.length; nextIndex += 1) {
          const nextActivity = activities[nextIndex];
          const nextAction = (nextActivity.action || "").toLowerCase();

          if (nextAction === "search") {
            break;
          }

          if (nextAction === "save") {
            saveActivity = nextActivity;
            break;
          }
        }

        const saveDetails = saveActivity && saveActivity.details ? saveActivity.details : {};

        processRows.push({
          id: activity.id,
          visit_time: activity.visit_time,
          action: activity.action,
          summary: activity.summary,
          folder_location: details.folder_location || "",
          selected_folder: details.selected_folder || "",
          selected_sub_folder: details.selected_sub_folder || "",
          selected_files: Array.isArray(details.selected_files)
            ? details.selected_files.join(", ")
            : (details.selected_files || ""),
          keyword: details.keyword || "",
          natural_keyword: details.natural_keyword || "",
          result_count: details.result_count || 0,
          selected_row_count: saveActivity
            ? (saveDetails.selected_row_count || details.selected_row_count || 0)
            : (details.selected_row_count || 0),
          master_name: saveDetails.master_name || "",
          saved_rows: saveDetails.saved_rows || 0
        });
      });

      return processRows;
    }
  },

  mounted() {
    this.loadVisit();
  },

  methods: {
    async loadVisit() {
      this.visitLoading = true;

      try {
        const { data } = await axios.get("/user/viewvisit?id=" + this.id, {
          headers: {
            Authorization: "Bearer " + this.access_token,
            "Content-type": "application/json"
          }
        });

        if (data.status === 200) {
          this.selectedVisit = data.data;
        }
      } catch (error) {
        console.log(error.response);
      } finally {
        this.visitLoading = false;
      }
    }
  }
};
</script>

<style scoped>
.inner-card {
  border: 1px solid #e9ecef;
  border-radius: 12px;
}

.break-word {
  word-break: break-word;
}
</style>
